import { useNavigate } from 'react-router-dom';

export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="lg:w-1/2 w-full">
              <div className="rounded-4xl overflow-hidden" style={{ borderRadius: '40px', boxShadow: '0 4px 24px rgba(0,0,0,0.05)' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20creative%20woman%20working%20at%20bright%20modern%20home%20office%20desk%2C%20multiple%20monitors%20displaying%20colorful%20spreadsheet%20dashboards%20and%20product%20comparison%20views%2C%20natural%20sunlight%20pouring%20through%20large%20windows%2C%20indoor%20plants%20and%20personal%20touches%20creating%20warm%20inviting%20atmosphere%2C%20professional%20yet%20relaxed%20work%20environment%2C%20contemporary%20female%20entrepreneur%20lifestyle%2C%20candid%20authentic%20moment%2C%20productive%20focused%20energy%20with%20soft%20warm%20lighting&width=800&height=960&seq=about-lifestyle-v2-2026&orientation=portrait"
                  alt="Superbuy Spreadsheet Hub - organized product research in action"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-1/2 w-full">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-5 whitespace-nowrap">
                <i className="ri-shield-check-line"></i> Why Trust Us
              </span>
              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-primary-800 leading-tight mb-6">
                Organized Research.
                <br />
                Better Purchases.
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4 max-w-lg">
                Superbuy Spreadsheet Hub is an independent educational platform dedicated to helping online shoppers organize their product research effectively. We are not affiliated with any official Superbuy services — we simply believe that structured, spreadsheet-based shopping leads to smarter decisions.
              </p>
              <p className="text-foreground-600 leading-relaxed mb-8 max-w-lg">
                Our platform aggregates category resources, comparison guides, and shopping strategies to help you save time, compare products accurately, and avoid common pitfalls in online shopping. Every resource is curated with care and updated regularly.
              </p>
              <button
                onClick={() => navigate('/article/superbuy-spreadsheet-guide')}
                className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-background-200/80 text-foreground-800 text-sm font-medium hover:bg-background-300 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <span>Read Full Guide</span>
                <i className="ri-arrow-right-up-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}